import React, { useState, useEffect } from "react";
import "./index.scss";
import FormGenerator from "../../../core/form-generator";
import {
  generateYearList,
  getUserFormConfig,
  MONTHS,
  PERFORMER_TYPE,
} from "./config";
import { Box } from "@mui/material";
import { handleFormValidation, PAGE_LIMIT } from "../../../utils";
import CustomButtonComponent from "../../../core/custom-button";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import { monthOptions } from "../../../pages/oem/training/training-report/helper";
import { getFinancialYears } from "../../../core/india-map/utils";

const CreateActualPlan = ({ setIsCreate, loadData, editData }) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [usersList, setUsersList] = useState([]);
  const resetHandler = () => {
    setFormData({});
    loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
  };
  const submitHandler = () => {
    const isValid = handleFormValidation(
      getUserFormConfig(usersList),
      setErrors,
      formData
    );
    if (isValid) {
      const payload = {
        ...formData,
        month: formData?.month?.value,
        financialYear: formData?.financialYear?.value,
      };
      if (editData?.id) {
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.TRAINING_TOUCH_POINTS}/${editData.id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Updated Successfully");
              resetHandler();
              setIsCreate(false);
            }
          })
          .catch((err) => console.error(err));
      } else {
        invokeApi(
          HTTP_METHODS.POST,
          `${HOSTNAME}${REST_URLS.TRAINING_TOUCH_POINTS}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Updated Successfully");
              resetHandler();
              setIsCreate(false);
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  const getUserList = () => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.USERS}`, null, {
      limit: 200,
    })
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          const result = res?.results?.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setUsersList(result);
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    if (editData?.id) {
      const {
        actualManHours,
        actualTouchPoints,
        financialYear,
        month,
        targetManHours,
        targetTouchPoints,
      } = editData;

      setFormData((prevVal) => ({
        ...prevVal,
        actualManHours,
        actualTouchPoints,
        financialYear: getFinancialYears()?.find(
          (ele) => ele.value === financialYear
        ),
        targetTouchPoints,
        targetManHours,
        month: MONTHS.find((ele) => ele.value === month),
      }));
    }
  }, [editData]);

  return (
    <div>
      <div className="form-con" style={{ width: "100%" }}>
        <FormGenerator
          config={getUserFormConfig(usersList)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 5,
            mb: 2,
            gridGap: "1rem",
            alignItems: "center",
          }}
        >
          <CustomButtonComponent
            variant="contained"
            color="primary"
            sx={{ width: "150px" }}
            onClick={submitHandler}
          >
            Submit
          </CustomButtonComponent>
        </Box>
      </div>
    </div>
  );
};

export default CreateActualPlan;
